import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import { AdPlacementSectionComponent } from './sections/ad-placement-section/ad-placement-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  PaymentsDataComponentConfig,
  PaymentsDataSectionComponent
} from '../common/payments-data-section/payments-data-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Umieszczenie reklamy',
  'Prognozowane opłaty',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  addRoadTrafficImpactControl: true,
  successUrl: '../inwestor',
  cancelUrl: '../wnioskodawca'
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  successUrl: '../umieszczenie-reklamy',
  cancelUrl: '../dane-wniosku',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const paymentsDataSectionConfig: PaymentsDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../umieszczenie-reklamy'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../oplaty',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const placementAdvertisingRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: AdPlacementSectionComponent,
    path: ':appId/umieszczenie-reklamy'
  },
  {
    component: PaymentsDataSectionComponent,
    path: ':appId/oplaty',
    data: paymentsDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
